import { Stack, TextField } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../../../store/hooks/useAppDispatch";
import { selectTabularSettingsState } from "../../../../../store/selectors/fieldsStateSelectors";
import { fieldsStateActions } from "../../../../../store/thunks/fieldStatesThunks";
import SubtotalLabelFormatPreview from "./SubtotalLabelFormatPreview";

interface Props {
  disabled?: boolean;
}

const SubtotalLabelFormat = ({ disabled }: Props) => {
  const settingsAreaValues = useSelector(selectTabularSettingsState);
  const dispatch = useAppDispatch();
  const [subtotalLabelFormatPrefix, setSubtotalLabelFormatPrefix] = useState<string>("");
  const [subtotalLabelFormatSuffix, setSubtotalLabelFormatSuffix] = useState<string>("");
  const isDisabled = settingsAreaValues.subtotalLabelPosition === "None" || !!disabled;
  const prefixInputRef = useRef<HTMLInputElement>(null);
  const suffixInputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    // TODO #209
    // eslint-disable-next-line @eslint-react/set-state-in-effect
    setSubtotalLabelFormatPrefix(settingsAreaValues.subtotalLabelFormatPrefix ?? "");
    // eslint-disable-next-line @eslint-react/set-state-in-effect
    setSubtotalLabelFormatSuffix(settingsAreaValues.subtotalLabelFormatSuffix ?? "");
  }, [settingsAreaValues.subtotalLabelFormatPrefix, settingsAreaValues.subtotalLabelFormatSuffix]);

  const handlePrefixEntered = () => {
    dispatch(fieldsStateActions.updateSettings({ settings: { subtotalLabelFormatPrefix: subtotalLabelFormatPrefix } }));
  };

  const handleSuffixEntered = () => {
    dispatch(fieldsStateActions.updateSettings({ settings: { subtotalLabelFormatSuffix: subtotalLabelFormatSuffix } }));
  };

  return (
    <Stack spacing={1} sx={{ py: 1 }}>
      <Stack direction="row" spacing={1}>
        <TextField
          label="Prefix"
          value={subtotalLabelFormatPrefix}
          onChange={(evt) => setSubtotalLabelFormatPrefix(evt.target.value)}
          onKeyDown={(evt) => {
            if (evt.key === "Enter") {
              evt.preventDefault();
              evt.stopPropagation();
              if (prefixInputRef.current) {
                prefixInputRef.current.blur();
              }
            }
          }}
          onBlur={handlePrefixEntered}
          disabled={isDisabled}
          inputRef={prefixInputRef}
        />
        <TextField
          label="Suffix"
          value={subtotalLabelFormatSuffix}
          onChange={(evt) => setSubtotalLabelFormatSuffix(evt.target.value)}
          onKeyDown={(evt) => {
            if (evt.key === "Enter") {
              evt.preventDefault();
              evt.stopPropagation();
              if (suffixInputRef.current) {
                suffixInputRef.current.blur();
              }
            }
          }}
          onBlur={handleSuffixEntered}
          disabled={isDisabled}
          inputRef={suffixInputRef}
        />
      </Stack>
      <SubtotalLabelFormatPreview
        subtotalLabelFormatPrefix={subtotalLabelFormatPrefix}
        subtotalLabelFormatSuffix={subtotalLabelFormatSuffix}
        isDisabled={isDisabled}
      />
    </Stack>
  );
};

export default SubtotalLabelFormat;
